import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-confirm',
  standalone: false,
  templateUrl: './confirm.component.html',
  styleUrl: './confirm.component.css',
})
export class ConfirmComponent {

  data = inject(MAT_DIALOG_DATA);

}

export type ConfirmDialogData = {
  title?: string
  message: SafeHtml
  cancelLabel?: string
  confirmLabel?: string
  hideCancel?: boolean
}
